// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PmshS","top":"styles_top__1QEpH"};